/* tslint:disable */
/* eslint-disable */
/**
 * ElisTech API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.0
 * Contact: info@ideatech.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiV1AnomalyAnomalyIdDelete200Response } from '../models';
// @ts-ignore
import type { ApiV1AnomalyAnomalyIdGet200Response } from '../models';
// @ts-ignore
import type { ApiV1AnomalyAnomalyIdPatchRequest } from '../models';
// @ts-ignore
import type { ApiV1AnomalyAnomalyIdPhotoPhotoIdDelete200Response } from '../models';
// @ts-ignore
import type { ApiV1AnomalyAnomalyIdPhotoPost200Response } from '../models';
/**
 * AnomalyApi - axios parameter creator
 */
export const AnomalyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete an anomaly
         * @param {string} anomalyId Anomaly UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnomalyAnomalyIdDelete: async (anomalyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'anomalyId' is not null or undefined
            assertParamExists('apiV1AnomalyAnomalyIdDelete', 'anomalyId', anomalyId)
            const localVarPath = `/api/v1/anomaly/{anomalyId}`
                .replace('{anomalyId}', encodeURIComponent(String(anomalyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an anomaly
         * @param {string} anomalyId Anomaly UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnomalyAnomalyIdDelete_1: async (anomalyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'anomalyId' is not null or undefined
            assertParamExists('apiV1AnomalyAnomalyIdDelete_1', 'anomalyId', anomalyId)
            const localVarPath = `/api/v1/anomaly/{anomalyId}`
                .replace('{anomalyId}', encodeURIComponent(String(anomalyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get anomaly details
         * @param {string} anomalyId Anomaly UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnomalyAnomalyIdGet: async (anomalyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'anomalyId' is not null or undefined
            assertParamExists('apiV1AnomalyAnomalyIdGet', 'anomalyId', anomalyId)
            const localVarPath = `/api/v1/anomaly/{anomalyId}`
                .replace('{anomalyId}', encodeURIComponent(String(anomalyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get anomaly details
         * @param {string} anomalyId Anomaly UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnomalyAnomalyIdGet_2: async (anomalyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'anomalyId' is not null or undefined
            assertParamExists('apiV1AnomalyAnomalyIdGet_2', 'anomalyId', anomalyId)
            const localVarPath = `/api/v1/anomaly/{anomalyId}`
                .replace('{anomalyId}', encodeURIComponent(String(anomalyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an anomaly
         * @param {string} anomalyId Anomaly UUID
         * @param {ApiV1AnomalyAnomalyIdPatchRequest} [apiV1AnomalyAnomalyIdPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnomalyAnomalyIdPatch: async (anomalyId: string, apiV1AnomalyAnomalyIdPatchRequest?: ApiV1AnomalyAnomalyIdPatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'anomalyId' is not null or undefined
            assertParamExists('apiV1AnomalyAnomalyIdPatch', 'anomalyId', anomalyId)
            const localVarPath = `/api/v1/anomaly/{anomalyId}`
                .replace('{anomalyId}', encodeURIComponent(String(anomalyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1AnomalyAnomalyIdPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an anomaly
         * @param {string} anomalyId Anomaly UUID
         * @param {ApiV1AnomalyAnomalyIdPatchRequest} [apiV1AnomalyAnomalyIdPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnomalyAnomalyIdPatch_3: async (anomalyId: string, apiV1AnomalyAnomalyIdPatchRequest?: ApiV1AnomalyAnomalyIdPatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'anomalyId' is not null or undefined
            assertParamExists('apiV1AnomalyAnomalyIdPatch_3', 'anomalyId', anomalyId)
            const localVarPath = `/api/v1/anomaly/{anomalyId}`
                .replace('{anomalyId}', encodeURIComponent(String(anomalyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1AnomalyAnomalyIdPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a photo from an anomaly
         * @param {string} anomalyId Anomaly UUID
         * @param {string} photoId Photo UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnomalyAnomalyIdPhotoPhotoIdDelete: async (anomalyId: string, photoId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'anomalyId' is not null or undefined
            assertParamExists('apiV1AnomalyAnomalyIdPhotoPhotoIdDelete', 'anomalyId', anomalyId)
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('apiV1AnomalyAnomalyIdPhotoPhotoIdDelete', 'photoId', photoId)
            const localVarPath = `/api/v1/anomaly/{anomalyId}/photo/{photoId}`
                .replace('{anomalyId}', encodeURIComponent(String(anomalyId)))
                .replace('{photoId}', encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a photo from an anomaly
         * @param {string} anomalyId Anomaly UUID
         * @param {string} photoId Photo UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnomalyAnomalyIdPhotoPhotoIdDelete_4: async (anomalyId: string, photoId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'anomalyId' is not null or undefined
            assertParamExists('apiV1AnomalyAnomalyIdPhotoPhotoIdDelete_4', 'anomalyId', anomalyId)
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('apiV1AnomalyAnomalyIdPhotoPhotoIdDelete_4', 'photoId', photoId)
            const localVarPath = `/api/v1/anomaly/{anomalyId}/photo/{photoId}`
                .replace('{anomalyId}', encodeURIComponent(String(anomalyId)))
                .replace('{photoId}', encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload a photo to an anomaly
         * @param {string} anomalyId Anomaly UUID
         * @param {Array<File>} photos Photo files (JPEG, PNG, etc.)
         * @param {Array<number | null>} [heading] Per-photo GPS heading array (degrees) for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnomalyAnomalyIdPhotoPost: async (anomalyId: string, photos: Array<File>, heading?: Array<number | null>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'anomalyId' is not null or undefined
            assertParamExists('apiV1AnomalyAnomalyIdPhotoPost', 'anomalyId', anomalyId)
            // verify required parameter 'photos' is not null or undefined
            assertParamExists('apiV1AnomalyAnomalyIdPhotoPost', 'photos', photos)
            const localVarPath = `/api/v1/anomaly/{anomalyId}/photo`
                .replace('{anomalyId}', encodeURIComponent(String(anomalyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (photos) {
                photos.forEach((element) => {
                    localVarFormParams.append('photos[]', element as any);
                })
            }

            if (heading) {
                localVarFormParams.append('heading[]', heading.join(COLLECTION_FORMATS.csv));
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload a photo to an anomaly
         * @param {string} anomalyId Anomaly UUID
         * @param {Array<File>} photos Photo files (JPEG, PNG, etc.)
         * @param {Array<number | null>} [heading] Per-photo GPS heading array (degrees) for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnomalyAnomalyIdPhotoPost_5: async (anomalyId: string, photos: Array<File>, heading?: Array<number | null>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'anomalyId' is not null or undefined
            assertParamExists('apiV1AnomalyAnomalyIdPhotoPost_5', 'anomalyId', anomalyId)
            // verify required parameter 'photos' is not null or undefined
            assertParamExists('apiV1AnomalyAnomalyIdPhotoPost_5', 'photos', photos)
            const localVarPath = `/api/v1/anomaly/{anomalyId}/photo`
                .replace('{anomalyId}', encodeURIComponent(String(anomalyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (photos) {
                photos.forEach((element) => {
                    localVarFormParams.append('photos[]', element as any);
                })
            }

            if (heading) {
                localVarFormParams.append('heading[]', heading.join(COLLECTION_FORMATS.csv));
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnomalyApi - functional programming interface
 */
export const AnomalyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnomalyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete an anomaly
         * @param {string} anomalyId Anomaly UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AnomalyAnomalyIdDelete(anomalyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1AnomalyAnomalyIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AnomalyAnomalyIdDelete(anomalyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnomalyApi.apiV1AnomalyAnomalyIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an anomaly
         * @param {string} anomalyId Anomaly UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AnomalyAnomalyIdDelete_1(anomalyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1AnomalyAnomalyIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AnomalyAnomalyIdDelete_1(anomalyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnomalyApi.apiV1AnomalyAnomalyIdDelete_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get anomaly details
         * @param {string} anomalyId Anomaly UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AnomalyAnomalyIdGet(anomalyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1AnomalyAnomalyIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AnomalyAnomalyIdGet(anomalyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnomalyApi.apiV1AnomalyAnomalyIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get anomaly details
         * @param {string} anomalyId Anomaly UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AnomalyAnomalyIdGet_2(anomalyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1AnomalyAnomalyIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AnomalyAnomalyIdGet_2(anomalyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnomalyApi.apiV1AnomalyAnomalyIdGet_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an anomaly
         * @param {string} anomalyId Anomaly UUID
         * @param {ApiV1AnomalyAnomalyIdPatchRequest} [apiV1AnomalyAnomalyIdPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AnomalyAnomalyIdPatch(anomalyId: string, apiV1AnomalyAnomalyIdPatchRequest?: ApiV1AnomalyAnomalyIdPatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1AnomalyAnomalyIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AnomalyAnomalyIdPatch(anomalyId, apiV1AnomalyAnomalyIdPatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnomalyApi.apiV1AnomalyAnomalyIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an anomaly
         * @param {string} anomalyId Anomaly UUID
         * @param {ApiV1AnomalyAnomalyIdPatchRequest} [apiV1AnomalyAnomalyIdPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AnomalyAnomalyIdPatch_3(anomalyId: string, apiV1AnomalyAnomalyIdPatchRequest?: ApiV1AnomalyAnomalyIdPatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1AnomalyAnomalyIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AnomalyAnomalyIdPatch_3(anomalyId, apiV1AnomalyAnomalyIdPatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnomalyApi.apiV1AnomalyAnomalyIdPatch_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a photo from an anomaly
         * @param {string} anomalyId Anomaly UUID
         * @param {string} photoId Photo UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AnomalyAnomalyIdPhotoPhotoIdDelete(anomalyId: string, photoId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1AnomalyAnomalyIdPhotoPhotoIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AnomalyAnomalyIdPhotoPhotoIdDelete(anomalyId, photoId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnomalyApi.apiV1AnomalyAnomalyIdPhotoPhotoIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a photo from an anomaly
         * @param {string} anomalyId Anomaly UUID
         * @param {string} photoId Photo UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AnomalyAnomalyIdPhotoPhotoIdDelete_4(anomalyId: string, photoId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1AnomalyAnomalyIdPhotoPhotoIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AnomalyAnomalyIdPhotoPhotoIdDelete_4(anomalyId, photoId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnomalyApi.apiV1AnomalyAnomalyIdPhotoPhotoIdDelete_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload a photo to an anomaly
         * @param {string} anomalyId Anomaly UUID
         * @param {Array<File>} photos Photo files (JPEG, PNG, etc.)
         * @param {Array<number | null>} [heading] Per-photo GPS heading array (degrees) for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AnomalyAnomalyIdPhotoPost(anomalyId: string, photos: Array<File>, heading?: Array<number | null>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1AnomalyAnomalyIdPhotoPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AnomalyAnomalyIdPhotoPost(anomalyId, photos, heading, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnomalyApi.apiV1AnomalyAnomalyIdPhotoPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload a photo to an anomaly
         * @param {string} anomalyId Anomaly UUID
         * @param {Array<File>} photos Photo files (JPEG, PNG, etc.)
         * @param {Array<number | null>} [heading] Per-photo GPS heading array (degrees) for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AnomalyAnomalyIdPhotoPost_5(anomalyId: string, photos: Array<File>, heading?: Array<number | null>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1AnomalyAnomalyIdPhotoPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AnomalyAnomalyIdPhotoPost_5(anomalyId, photos, heading, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnomalyApi.apiV1AnomalyAnomalyIdPhotoPost_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnomalyApi - factory interface
 */
export const AnomalyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnomalyApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete an anomaly
         * @param {string} anomalyId Anomaly UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnomalyAnomalyIdDelete(anomalyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1AnomalyAnomalyIdDelete200Response> {
            return localVarFp.apiV1AnomalyAnomalyIdDelete(anomalyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an anomaly
         * @param {string} anomalyId Anomaly UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnomalyAnomalyIdDelete_1(anomalyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1AnomalyAnomalyIdDelete200Response> {
            return localVarFp.apiV1AnomalyAnomalyIdDelete_1(anomalyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get anomaly details
         * @param {string} anomalyId Anomaly UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnomalyAnomalyIdGet(anomalyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1AnomalyAnomalyIdGet200Response> {
            return localVarFp.apiV1AnomalyAnomalyIdGet(anomalyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get anomaly details
         * @param {string} anomalyId Anomaly UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnomalyAnomalyIdGet_2(anomalyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1AnomalyAnomalyIdGet200Response> {
            return localVarFp.apiV1AnomalyAnomalyIdGet_2(anomalyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an anomaly
         * @param {string} anomalyId Anomaly UUID
         * @param {ApiV1AnomalyAnomalyIdPatchRequest} [apiV1AnomalyAnomalyIdPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnomalyAnomalyIdPatch(anomalyId: string, apiV1AnomalyAnomalyIdPatchRequest?: ApiV1AnomalyAnomalyIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1AnomalyAnomalyIdGet200Response> {
            return localVarFp.apiV1AnomalyAnomalyIdPatch(anomalyId, apiV1AnomalyAnomalyIdPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an anomaly
         * @param {string} anomalyId Anomaly UUID
         * @param {ApiV1AnomalyAnomalyIdPatchRequest} [apiV1AnomalyAnomalyIdPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnomalyAnomalyIdPatch_3(anomalyId: string, apiV1AnomalyAnomalyIdPatchRequest?: ApiV1AnomalyAnomalyIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1AnomalyAnomalyIdGet200Response> {
            return localVarFp.apiV1AnomalyAnomalyIdPatch_3(anomalyId, apiV1AnomalyAnomalyIdPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a photo from an anomaly
         * @param {string} anomalyId Anomaly UUID
         * @param {string} photoId Photo UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnomalyAnomalyIdPhotoPhotoIdDelete(anomalyId: string, photoId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1AnomalyAnomalyIdPhotoPhotoIdDelete200Response> {
            return localVarFp.apiV1AnomalyAnomalyIdPhotoPhotoIdDelete(anomalyId, photoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a photo from an anomaly
         * @param {string} anomalyId Anomaly UUID
         * @param {string} photoId Photo UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnomalyAnomalyIdPhotoPhotoIdDelete_4(anomalyId: string, photoId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1AnomalyAnomalyIdPhotoPhotoIdDelete200Response> {
            return localVarFp.apiV1AnomalyAnomalyIdPhotoPhotoIdDelete_4(anomalyId, photoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload a photo to an anomaly
         * @param {string} anomalyId Anomaly UUID
         * @param {Array<File>} photos Photo files (JPEG, PNG, etc.)
         * @param {Array<number | null>} [heading] Per-photo GPS heading array (degrees) for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnomalyAnomalyIdPhotoPost(anomalyId: string, photos: Array<File>, heading?: Array<number | null>, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1AnomalyAnomalyIdPhotoPost200Response> {
            return localVarFp.apiV1AnomalyAnomalyIdPhotoPost(anomalyId, photos, heading, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload a photo to an anomaly
         * @param {string} anomalyId Anomaly UUID
         * @param {Array<File>} photos Photo files (JPEG, PNG, etc.)
         * @param {Array<number | null>} [heading] Per-photo GPS heading array (degrees) for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnomalyAnomalyIdPhotoPost_5(anomalyId: string, photos: Array<File>, heading?: Array<number | null>, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1AnomalyAnomalyIdPhotoPost200Response> {
            return localVarFp.apiV1AnomalyAnomalyIdPhotoPost_5(anomalyId, photos, heading, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnomalyApi - object-oriented interface
 */
export class AnomalyApi extends BaseAPI {
    /**
     * 
     * @summary Delete an anomaly
     * @param {string} anomalyId Anomaly UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1AnomalyAnomalyIdDelete(anomalyId: string, options?: RawAxiosRequestConfig) {
        return AnomalyApiFp(this.configuration).apiV1AnomalyAnomalyIdDelete(anomalyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an anomaly
     * @param {string} anomalyId Anomaly UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1AnomalyAnomalyIdDelete_1(anomalyId: string, options?: RawAxiosRequestConfig) {
        return AnomalyApiFp(this.configuration).apiV1AnomalyAnomalyIdDelete_1(anomalyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get anomaly details
     * @param {string} anomalyId Anomaly UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1AnomalyAnomalyIdGet(anomalyId: string, options?: RawAxiosRequestConfig) {
        return AnomalyApiFp(this.configuration).apiV1AnomalyAnomalyIdGet(anomalyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get anomaly details
     * @param {string} anomalyId Anomaly UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1AnomalyAnomalyIdGet_2(anomalyId: string, options?: RawAxiosRequestConfig) {
        return AnomalyApiFp(this.configuration).apiV1AnomalyAnomalyIdGet_2(anomalyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an anomaly
     * @param {string} anomalyId Anomaly UUID
     * @param {ApiV1AnomalyAnomalyIdPatchRequest} [apiV1AnomalyAnomalyIdPatchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1AnomalyAnomalyIdPatch(anomalyId: string, apiV1AnomalyAnomalyIdPatchRequest?: ApiV1AnomalyAnomalyIdPatchRequest, options?: RawAxiosRequestConfig) {
        return AnomalyApiFp(this.configuration).apiV1AnomalyAnomalyIdPatch(anomalyId, apiV1AnomalyAnomalyIdPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an anomaly
     * @param {string} anomalyId Anomaly UUID
     * @param {ApiV1AnomalyAnomalyIdPatchRequest} [apiV1AnomalyAnomalyIdPatchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1AnomalyAnomalyIdPatch_3(anomalyId: string, apiV1AnomalyAnomalyIdPatchRequest?: ApiV1AnomalyAnomalyIdPatchRequest, options?: RawAxiosRequestConfig) {
        return AnomalyApiFp(this.configuration).apiV1AnomalyAnomalyIdPatch_3(anomalyId, apiV1AnomalyAnomalyIdPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a photo from an anomaly
     * @param {string} anomalyId Anomaly UUID
     * @param {string} photoId Photo UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1AnomalyAnomalyIdPhotoPhotoIdDelete(anomalyId: string, photoId: string, options?: RawAxiosRequestConfig) {
        return AnomalyApiFp(this.configuration).apiV1AnomalyAnomalyIdPhotoPhotoIdDelete(anomalyId, photoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a photo from an anomaly
     * @param {string} anomalyId Anomaly UUID
     * @param {string} photoId Photo UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1AnomalyAnomalyIdPhotoPhotoIdDelete_4(anomalyId: string, photoId: string, options?: RawAxiosRequestConfig) {
        return AnomalyApiFp(this.configuration).apiV1AnomalyAnomalyIdPhotoPhotoIdDelete_4(anomalyId, photoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload a photo to an anomaly
     * @param {string} anomalyId Anomaly UUID
     * @param {Array<File>} photos Photo files (JPEG, PNG, etc.)
     * @param {Array<number | null>} [heading] Per-photo GPS heading array (degrees) for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1AnomalyAnomalyIdPhotoPost(anomalyId: string, photos: Array<File>, heading?: Array<number | null>, options?: RawAxiosRequestConfig) {
        return AnomalyApiFp(this.configuration).apiV1AnomalyAnomalyIdPhotoPost(anomalyId, photos, heading, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload a photo to an anomaly
     * @param {string} anomalyId Anomaly UUID
     * @param {Array<File>} photos Photo files (JPEG, PNG, etc.)
     * @param {Array<number | null>} [heading] Per-photo GPS heading array (degrees) for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1AnomalyAnomalyIdPhotoPost_5(anomalyId: string, photos: Array<File>, heading?: Array<number | null>, options?: RawAxiosRequestConfig) {
        return AnomalyApiFp(this.configuration).apiV1AnomalyAnomalyIdPhotoPost_5(anomalyId, photos, heading, options).then((request) => request(this.axios, this.basePath));
    }
}

